import {AbstractStorageModule} from "@/services/storage/AbstractStorageModule";
import {app} from "@/app";

export class Shop extends AbstractStorageModule {
  domain: null|string = null;
  routesRoot: string = '/';
  currency: null|string = null;

  resolve() {

    /* Shop domain `<shop-name>.myshopify.com` */
    this.domain = app.configOption('shopDomain');
    // @ts-ignore
    if(typeof this.domain !== 'string') this.domain = window?.Shopify?.shop ?? null;
    // @ts-ignore
    if(typeof this.domain !== 'string') this.domain = window?.Shopify?.Checkout?.apiHost ?? null;

    // @ts-ignore
    this.routesRoot = window?.Shopify?.routes?.root ?? '/';

    // @ts-ignore
    this.currency = window?.ShopifyAnalytics?.meta?.currency ?? null;
  }
}
